import config from 'config'

const customerApi = `${config.apiHost}/oem-customer`

export default {
    getChannels: {
        url: `${customerApi}/api/oem_miniso/channels`,
        type: 'GET',
    },

    updateChannel: {
        url: `${customerApi}/api/oem_miniso/channels/{id}`,
        type: 'PUT',
    },

    addChannel: {
        url: `${customerApi}/api/oem_miniso/channels`,
        type: 'POST',
    },

    deleteChannel: {
        url: `${customerApi}/api/oem_miniso/channels/{id}`,
        type: 'DELETE',
    },

    getDrainageCont: {
        url: `${customerApi}/api/oem_miniso/channels/{id}`,
        type: 'GET',
    },

    setDrainageCont: {
        url: `${customerApi}/api/oem_miniso/channels/{id}`,
        type: 'PUT',
    },
}
